import React from "react";
import { Modal, Button, ModalHeader, ModalBody } from "reactstrap";
import { Formik } from "formik";
import axiosInstance from "../../axios-project";

class ContactInputModal extends React.Component {
  render() {
    return (
      <div>
        <Modal
          toggle={this.props.toggleContactInputModal}
          isOpen={this.props.showContactInputModal}
        >
          <ModalHeader toggle={this.props.toggleContactInputModal}>
            Contact
          </ModalHeader>
          <ModalBody>
            <div>
              <small className={"d-block"}>
                <span style={{ color: "red" }}>*</span> required
              </small>
              <Formik
                initialValues={this.props.currentContact}
                onSubmit={(values, { setSubmitting }) => {
                  this.props.toggleContactInputModal();
                  if (this.props.currentContact) {
                    axiosInstance
                      .put(
                        "/contact/" + this.props.currentContact.contact_id,
                        values
                      )
                      .then(response => {
                        this.props.fetchContacts(
                          this.props.currentContact.organization_id
                        );
                      });
                  } else {
                    values.contact_id = 0;
                    values.organization_id = this.props.currentOrganization.organization_id;
                    axiosInstance.post("/contact", values).then(response => {
                      this.props.fetchContacts(
                        this.props.currentOrganization.organization_id
                      );
                    });
                  }
                }}
              >
                {({ values, handleChange, handleBlur, handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="form-row">
                      <label className="col-sm-3">Title</label>
                      <input
                        type="text"
                        name="contact_title"
                        maxLength="200"
                        className="form-control col-sm-6"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.contact_title}
                      />
                    </div>
                    <div className="form-row">
                      <label className="col-sm-3 required">Name</label>
                      <input
                        required
                        type="text"
                        name="contact_name"
                        maxLength="30"
                        className="form-control col-sm-6"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.contact_name}
                      />
                    </div>
                    <div className="form-row">
                      <label className="col-sm-3">Email</label>
                      <input
                        type="email"
                        name="contact_email"
                        maxLength="30"
                        className="form-control col-sm-6"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.contact_email}
                      />
                    </div>
                    <div className="form-row">
                      <label className="col-sm-3">Phone</label>
                      <input
                        type="number"
                        name="contact_phone"
                        maxLength="30"
                        className="form-control col-sm-6"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.contact_phone}
                      />
                    </div>
                    <div className="form-row">
                      <label className="col-sm-3">Notes</label>
                      <textarea
                        required
                        name="notes"
                        maxLength="3000"
                        className="form-control col-sm-6"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.notes || ""}
                      />
                    </div>
                    <br />
                    <Button color="primary" type="submit">
                      Submit
                    </Button>{" "}
                    <Button
                      color="secondary"
                      onClick={this.props.toggleContactInputModal}
                    >
                      Cancel
                    </Button>
                  </form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
export default ContactInputModal;
